export const isBrowser = () => typeof window === "object";
export const isSSR = () => SSR;
export const isPrerendering = () => isBrowser() && window.location.href.includes("prerendering=true");
export const isSilent = () => SILENT || (isBrowser() && window.location.href.includes("silent=true"));
export const isRelease = () => RELEASE;
